import {HTTP_METHODS} from '../httpMethods'

const UNSAFE_SEGMENT_PATTERN = /(\.\.|\/|\\|%2f|%5c|%2e%2e)/i

const toSafePathSegment = value => {
  const raw = String(value ?? '').trim()

  if (!raw || UNSAFE_SEGMENT_PATTERN.test(raw)) {
    throw new Error(`Unsafe path segment: ${raw}`)
  }

  return encodeURIComponent(raw)
}

export const UPLOAD_IMAGES_CONFIG = {
  UPLOAD_IMAGES: () => ({
    endPoint: `image/upload`,
    method: HTTP_METHODS.POST,
    headers: {scope: 'pepsi'},
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
    contentType: 'multipart/form-data',
    multipart: 'multipart',
  }),
  UPLOAD_PROMOTION_IMAGES: () => ({
    endPoint: `promotion/image/upload`,
    method: HTTP_METHODS.POST,
    headers: {scope: 'pepsi'},
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
    contentType: 'multipart/form-data',
    multipart: 'multipart',
  }),
  UPLOAD_PRODUCT_MEDIA: productId => ({
    endPoint: `product/${productId}/media`,
    method: HTTP_METHODS.PUT,
    headers: {scope: 'pepsi'},
    baseUrlKey: 'inventoryApiUrl',
    contentType: 'multipart/form-data',
    multipart: 'multipart',
  }),
  GET_PRODUCT_MEDIA_SAS_TOKEN: (productId, extraHeaders = {}) => ({
    endPoint: `product/${toSafePathSegment(productId)}/media/uploads`,
    method: HTTP_METHODS.POST,
    headers: {scope: 'pepsi', ...extraHeaders},
    baseUrlKey: 'inventoryApiUrl',
  }),
  GET_MEDIA_UPLOAD_URLS: (extraHeaders = {}) => ({
    endPoint: 'media/uploads',
    method: HTTP_METHODS.POST,
    queryParams: {scope: 'pepsi'},
    headers: extraHeaders,
    baseUrlKey: 'inventoryApiUrl',
  }),
  UPDATE_PRODUCT_MEDIA_METADATA: (productId, extraHeaders = {}) => ({
    endPoint: `product/${toSafePathSegment(productId)}/media/metadata`,
    method: HTTP_METHODS.PUT,
    headers: {scope: 'pepsi', ...extraHeaders},
    baseUrlKey: 'inventoryApiUrl',
  }),
  DELETE_PRODUCT_MEDIA: (productId, displayOrder) => ({
    endPoint: `product/${productId}/media/order/${displayOrder}`,
    method: HTTP_METHODS.DELETE,
    headers: {scope: 'pepsi'},
    baseUrlKey: 'inventoryApiUrl',
  }),
}
